import React from 'react';
import Icon from 'components/AppIcon';
import Image from 'components/AppImage';

const TESTIMONIALS = [
{
  id: 1,
  name: 'Priya Sharma',
  role: 'Growth Member · Portfolio +34%',
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_13ab42514-1763298452113.png",
  avatarAlt: 'Professional South Asian woman with dark hair smiling confidently in business attire',
  quote: 'WIN transformed how I think about money. My portfolio grew 34% in one year with the community\'s guidance.'
},
{
  id: 2,
  name: 'Marcus & Alicia Chen',
  role: 'Pinnacle Member · Real Estate Investor',
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_10a19f109-1763296358145.png",
  avatarAlt: 'Asian American woman in professional blazer with confident smile in modern office setting',
  quote: 'The Women-Led business showcase connected me with my first real estate investment partner.'
},
{
  id: 3,
  name: 'Destiny Williams',
  role: 'Seed Member · Beginner Investor',
  avatar: "https://images.unsplash.com/photo-1718609256733-b1c7645735f1",
  avatarAlt: 'Young Black woman with natural hair wearing bright yellow top smiling warmly outdoors',
  quote: 'As a beginner, I was intimidated. WIN\'s community made investing feel accessible and exciting!'
}];


const STATS = [
{ value: '12,400+', label: 'Active Members' },
{ value: '$2.8M', label: 'Invested Together' },
{ value: '94%', label: 'Member Satisfaction' }];


export default function BrandPanel() {
  return (
    <div className="hidden lg:flex flex-col h-full relative overflow-hidden"
    style={{ background: 'var(--color-primary)', padding: '48px 40px' }}>
      {/* Background decoration */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute -top-20 -right-20 rounded-full opacity-10"
        style={{ width: 300, height: 300, background: 'var(--color-accent)' }} />
        <div className="absolute -bottom-20 -left-20 rounded-full opacity-5"
        style={{ width: 400, height: 400, background: 'var(--color-accent)' }} />
      </div>
      {/* Logo */}
      <div className="flex items-center gap-3 mb-10 relative z-10">
        <div className="rounded-xl flex items-center justify-center"
        style={{ width: 48, height: 48, background: 'rgba(133,113,77,0.2)' }}>
          <Icon name="Coins" size={26} color="var(--color-accent)" strokeWidth={1.5} />
        </div>
        <div>
          <div style={{ fontFamily: 'var(--font-heading)', fontSize: '1.5rem', fontWeight: 700, color: '#FFFFFF', letterSpacing: '0.15em' }}>WIN</div>
          <div style={{ fontFamily: 'var(--font-caption)', fontSize: '0.6875rem', color: 'rgba(133,113,77,0.8)', letterSpacing: '0.12em', textTransform: 'uppercase' }}>Women Invest Network</div>
        </div>
      </div>
      {/* Headline */}
      <div className="relative z-10 mb-8">
        <h1 style={{ fontFamily: 'var(--font-heading)', fontSize: '2.25rem', fontWeight: 700, color: '#FFFFFF', lineHeight: 1.2, marginBottom: 16 }}>
          Build Wealth.<br />
          <span style={{ color: 'var(--color-accent)' }}>Together.</span>
        </h1>
        <p style={{ fontFamily: 'var(--font-body)', fontSize: '1rem', color: 'rgba(255,255,255,0.75)', lineHeight: 1.6 }}>
          Join thousands of women investors building generational wealth through community, education, and curated opportunities.
        </p>
      </div>
      {/* Stats */}
      <div className="grid grid-cols-3 gap-4 mb-8 relative z-10">
        {STATS?.map((stat, i) =>
        <div key={i} className="rounded-xl p-4 text-center"
        style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(133,113,77,0.2)' }}>
            <div style={{ fontFamily: 'var(--font-data)', fontSize: '1.25rem', fontWeight: 700, color: 'var(--color-accent)' }}>{stat?.value}</div>
            <div style={{ fontFamily: 'var(--font-caption)', fontSize: '0.75rem', color: 'rgba(255,255,255,0.6)', marginTop: 4 }}>{stat?.label}</div>
          </div>
        )}
      </div>
      {/* Testimonials */}
      <div className="flex-1 flex flex-col justify-end relative z-10">
        <div style={{ fontFamily: 'var(--font-caption)', fontSize: '0.8125rem', color: 'rgba(133,113,77,0.8)', fontWeight: 600, letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: 16 }}>
          Member Stories
        </div>
        <div className="flex flex-col gap-4">
          {TESTIMONIALS?.map((t) =>
          <div key={t?.id} className="rounded-xl p-4"
          style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)' }}>
              <div className="flex items-center gap-3 mb-2">
                <div className="rounded-full overflow-hidden flex-shrink-0" style={{ width: 36, height: 36 }}>
                  <Image src={t?.avatar} alt={t?.avatarAlt} className="w-full h-full object-cover" />
                </div>
                <div>
                  <div style={{ fontFamily: 'var(--font-caption)', fontWeight: 600, fontSize: '0.875rem', color: '#FFFFFF' }}>{t?.name}</div>
                  <div style={{ fontFamily: 'var(--font-caption)', fontSize: '0.75rem', color: 'var(--color-accent)' }}>{t?.role}</div>
                </div>
              </div>
              <p style={{ fontFamily: 'var(--font-body)', fontSize: '0.875rem', color: 'rgba(255,255,255,0.75)', fontStyle: 'italic', lineHeight: 1.5 }}>
                &ldquo;{t?.quote}&rdquo;
              </p>
            </div>
          )}
        </div>
      </div>
      {/* Tagline */}
      <div className="mt-6 pt-6 relative z-10" style={{ borderTop: '1px solid rgba(133,113,77,0.2)' }}>
        <p style={{ fontFamily: 'var(--font-body)', fontSize: '1rem', fontStyle: 'italic', color: 'rgba(255,255,255,0.6)', textAlign: 'center' }}>
          &ldquo;Invest In Each Other™&rdquo;
        </p>
      </div>
    </div>);

}